var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.icon)?_c('i',{staticClass:"item-icon"},[_c('font-awesome-icon',{attrs:{"icon":['far', _vm.item.icon]}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }